/**
 * Close pricelist <details> dropdowns when the user clicks outside.
 * Delegated + idempotent so multiple script tags or section reloads are safe.
 */
(function () {
  if (window.__collectionSearchPriceDownloadOutsideClose) return;
  window.__collectionSearchPriceDownloadOutsideClose = true;

  document.addEventListener('click', function (event) {
    document
      .querySelectorAll('details.collection-search__price-download[open]')
      .forEach(function (details) {
        if (!details.contains(event.target)) {
          details.open = false;
        }
      });
  });
})();
